
export enum Device {
	Apple = 1,
	Android = 2,
}